import firebase from "firebase";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDt7_alOwyDKe92v1pnneChGjW57CFF1Qg",
    authDomain: "projects-15cef.firebaseapp.com",
    projectId: "projects-15cef",
    storageBucket: "projects-15cef.appspot.com",
    messagingSenderId: "978868604449",
    appId: "1:978868604449:web:c626e7db1c9c0ddf54dd60",
    measurementId: "G-SK17TXM6R7"
});

const db = firebaseApp.firestore();

export default db;